import { connect } from 'react-redux';

import CreateUserFromBranchDialog from '../../components/CreateUserFromBranchDialog';
import { submitMode } from '../../constants';

import {
  openCreateUserDialogDispatch,
  handleUserInputChangeDispatch,
  submitUserDispatch,
  getBranches
} from '../../actions';

const mapStateToProps = (state, ownProps) => {
  return {
    openDialog: state.user.newUser.showCreateUserDialog,
    user: state.user.newUser.item,
    branch: state.branch.branch.item,
    isSaving: state.user.newUser.isSaving,
    branches: state.branches.allBranches.items,
    isLoadingBranches: state.branches.allBranches.isLoading,
    loggedInUser: state.users.user.item
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    openCreateUserDialog: (open) => {
      dispatch(openCreateUserDialogDispatch(open));
    },
    onHandleInputChange: (value, inputFieldName) => {
      dispatch(handleUserInputChangeDispatch(value, inputFieldName));
    },
    submitUser: (user) => {
      const mode = submitMode.CREATE;
      dispatch(submitUserDispatch(user, mode));
    },
    fetchAllBranches: () => {
      dispatch(getBranches());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateUserFromBranchDialog);
